/**
 * * end of cart upsell block part
 */
$(document).ready(function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cart_total = $(".gb-totals-total-value").first().text();
  if (amountFreeProduct > 0 && show_progress_bar) {
    // Check if premium-attachment-kit block is present (handles free gifts separately)
    const hasPremiumKit = document.querySelector('.premium-attachment-kit') !== null;
    
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
      return;
    }
    
    /*GB! free product added STARTS*/
    setTimeout(function () {
      var cart_total = $(".gb-totals-total-value").first().text();
      if (cart_total >= amountFreeProduct) {
        if ($(".cart-item").hasClass("gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          $(".gb-free-product-trigger").trigger("click");
        }
      } else {
        console.log("Removing free product - under threshold");
        $(".gb-remove-product").trigger("click");
      }
    }, 3000);
    $("body").on("click", ".gb-sumbit-free", function () {
      setTimeout(function () {
        if (cart_total >= amountFreeProduct) {
          if ($(".cart-item").hasClass("gb-find-remove-product")) {
          } else {
            $(".gb-free-product-trigger").trigger("click");
          }
        } else {
          $(".gb-remove-product").trigger("click");
        }
      }, 3000);
    });

    // $("body").on("click", ".shop-add-to-cart-button", function () {
    //   setTimeout(function () {
    //     var cart_total = $(".gb-totals-total-value").first().text();
    //     if (cart_total >= amount_free_product) {
    //       if ($(".cart-item").hasClass("gb-find-remove-product")) {
    //       } else {
    //         $(".gb-free-product-trigger").trigger("click");
    //       }
    //     } else {
    //       $(".gb-remove-product").trigger("click");
    //     }
    //   }, 3000);
    // });
  }

  $("body").on("click", ".gb-shipping-protection-button label.switch", async (e) => {
    if (e.target.tagName == "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    if (curElem.classList.contains("unchecked") && !curInputElem.checked) {
      if (spinAnim.style.display == "block" || curInputElem.checked) return;

      // $(".gb-product-shipping-protection-product-tirgger").trigger("click");
      const form = document.querySelector("form.shipping-protection-form");

      const formData = new FormData(form);
      if (!formData.get("id")) {
        console.error(
          "There is no shipping protection product selected. Please select the shipping product in the global theme settings",
        );
        return;
      }

      spinAnim.style.display = "block";

      try {
        const response = await fetch(routes.cart_add_url, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (response.ok) {
          spinAnim.style.display = "none";

          checkElem.style.display = "block";
        }
      } catch (err) {
        console.error("error at shipping protection form submission", err);
      }
      fetch(routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const cartDrawer = document.querySelector("#CartDrawer");
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
              curElem.classList.remove("unchecked");
              curElem.classList.add("checked");
              curInputElem.checked = true;
            });
          }
        })
        .catch((_err) => {
          curElem.classList.remove("unchecked");
          curElem.classList.add("checked");
          curInputElem.checked = true;
        });
    } else if (curElem.classList.contains("checked") && curInputElem.checked) {
      checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${shippingProductId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;
      if (!removeButton || !shippingItemIndex) {
        return;
      }

      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      const event = new CustomEvent("remove-shipping-protection", {
        detail: null,
      });
      cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", () => {
        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");
        curInputElem.removeAttribute("checked");
      });
    }
  });

  $("body").on("change", ".gb-change-variant_id", function () {
    var id_change = $(this).find(":selected").attr("data-variant-id");
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    $(this).closest(".gb-get-main-freq-pro").find(".product-variant-id").val(id_change);
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions to ensure ID parameter is present
document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/cart/add")) {
    const idInput = e.target.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      console.log("Preventing submission - missing id parameter");
      e.preventDefault();
      return false;
    }
  }
});

// Improve cart quantity handlers
$(document).ready(function () {
  // Ensure all cart quantity changes include product ID
  $(".cart-item .quantity__button, .cart-item .quantity__input").on("click change input", function () {
    const cartItem = $(this).closest(".cart-item");
    const variantId = $(this).closest(".quantity-input").find(".quantity__input").data("quantity-variant-id");

    // If this is a form submission, ensure the ID is included
    if ($(this).closest("form").length > 0) {
      let idInput = $(this).closest("form").find('input[name="id"]');
      if (idInput.length === 0 && variantId) {
        console.log("Adding missing ID input to cart form");
        $("<input>")
          .attr({
            type: "hidden",
            name: "id",
            value: variantId,
          })
          .appendTo($(this).closest("form"));
      } else if (idInput.length > 0 && variantId) {
        idInput.val(variantId);
      }
    }
  });

  // Add validation for cart drawer checkout button
  $("#CartDrawer-Checkout").on("click", function (e) {
    const form = $("#CartDrawer-Form");
    if (form.length === 0) return;

    // Check if there are any items in the cart
    const cartItems = form.find(".cart-item");
    if (cartItems.length === 0) {
      console.log("No items in cart, preventing checkout");
      e.preventDefault();
      return false;
    }

    console.log("Cart checkout with", cartItems.length, "items");
  });

  /**
   * * Prevent redirecting to checkout when pressing enter at quantity input
   */
  $(document).on("keydown", ".quantity__input", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      $(this).trigger("blur");
    }
  });
  // * End of handler
});

// Fix for frequently bought products add to cart
$(document).ready(function () {
  // Find all frequently bought product forms or buttons
  $(
    ".gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-trigger, .gb-product-shipping-protection-product-tirgger, .gb-product-sticky-add-to-cart-form",
  ).on("click", function (e) {
    const parentBlock = $(this).closest(".gb-get-main-freq-pro, form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }

    // Find the product ID input or data attribute
    let productId = null;

    // Check for direct ID input
    const idInput = parentBlock.find('input[name="id"]');
    if (idInput.length > 0 && idInput.val()) {
      productId = idInput.val();
    }
    // Check for variant ID on select
    else if (parentBlock.find(".gb-change-variant_id").length > 0) {
      const selectedOption = parentBlock.find(".gb-change-variant_id option:selected");
      if (selectedOption.length > 0) {
        productId = selectedOption.data("variant-id");
      }
    }
    // Check for product-variant-id input
    else if (parentBlock.find(".product-variant-id").length > 0) {
      productId = parentBlock.find(".product-variant-id").val();
    }
    // Check for data attributes on the button itself
    else if ($(this).data("variant-id")) {
      productId = $(this).data("variant-id");
    }

    console.log("Frequently bought product add to cart - ID:", productId);

    if (this.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;

    // If no product ID found, prevent submission
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }

    // Update or create the ID input
    if (idInput.length === 0) {
      console.log("Adding missing ID input to frequently bought product form");
      $("<input>")
        .attr({
          type: "hidden",
          name: "id",
          value: productId,
        })
        .appendTo(parentBlock);
    } else {
      idInput.val(productId);
    }

    // Ensure quantity is included
    let quantityInput = parentBlock.find('input[name="quantity"]');
    if (quantityInput.length === 0) {
      console.log("Adding default quantity input to frequently bought product form");
      $("<input>")
        .attr({
          type: "hidden",
          name: "quantity",
          value: 1,
        })
        .appendTo(parentBlock);
    } else if (!quantityInput.val() || quantityInput.val() < 1) {
      quantityInput.val(1);
    }
  });
});

/* ===== Mix-and-match colours + free 32GB memory card.  19 Sep 2026 =====
   1. On the 2- and 3-packs a colour dropdown appears for each unit, so a
      shopper can mix colours. The bundle price still applies because the
      automatic discounts count TOTAL quantity of the product, not per
      variant (verified live: 1 Orange + 1 Pink = the 2-pack price).
   2. Shows the free 32GB card as an included gift and adds it to every
      order at 0.00, normalised to exactly one card per cart.
   ===================================================================== */
(function () {
  'use strict';

  var GIFT_ID = 58882518286668;
  var GIFT_HANDLE = 'free-32gb-memory-card';
  var GIFT_IMG = 'https://muddybootskids.co.uk/cdn/shop/t/6/assets/mb-memory-card.png';

  function boot() {
    var sel = document.querySelector('.quantity-bundle-selector');
    var form = document.querySelector('form[action="/cart/add"]');
    var path = window.location.pathname;
    if (!sel || !form) return;
    if (path.indexOf('/products/') === -1) return;
    if (path.indexOf(GIFT_HANDLE) !== -1) return;
    if (document.getElementById('mb-gift-row')) return;

    var handle = path.split('/products/')[1].split('/')[0];

    var st = document.createElement('style');
    st.textContent = '.mb-colour-picker{margin:18px 0 4px}'
      + '.mb-colour-picker__title{font-size:14px;font-weight:600;color:#193D2A;margin-bottom:8px}'
      + '.mb-colour-picker__row{display:flex;align-items:center;gap:10px;margin-bottom:8px}'
      + '.mb-colour-picker__label{font-size:14px;color:#4A4A4A;min-width:92px}'
      + '.mb-colour-picker__select{flex:1;padding:9px 10px;border:1px solid #E2DDD2;border-radius:8px;background:#fff;font:inherit;font-size:14px;color:#193D2A;cursor:pointer}'
      + '.mb-colour-picker__select:focus{outline:none;border-color:#193D2A;box-shadow:0 0 0 3px rgba(25,61,42,.15)}'
      + '.mb-gift-row{display:flex;align-items:center;gap:12px;background:#E8822B;color:#fff;border-radius:10px;padding:10px 14px;margin:14px 0 4px}'
      + '.mb-gift-row img{width:40px;height:40px;object-fit:cover;border-radius:6px;background:#fff;flex:0 0 auto}'
      + '.mb-gift-row__name{font-weight:700;font-size:15px;flex:1}'
      + '.mb-gift-row__tag{font-weight:600;font-size:14px;white-space:nowrap;opacity:.95}'
      + '@media(max-width:600px){.mb-colour-picker__label{min-width:76px;font-size:13px}.mb-gift-row__name{font-size:14px}}';
    document.head.appendChild(st);

    var wrap = document.createElement('div');
    wrap.id = 'mb-colour-picker';
    wrap.className = 'mb-colour-picker';

    var gift = document.createElement('div');
    gift.id = 'mb-gift-row';
    gift.className = 'mb-gift-row';
    gift.innerHTML = '<img src="' + GIFT_IMG + '" alt="" width="40" height="40">'
      + '<span class="mb-gift-row__name">1&times; FREE 32GB Memory Card</span>'
      + '<span class="mb-gift-row__tag">INCLUDED</span>';

    sel.parentElement.insertBefore(wrap, sel.nextSibling);
    sel.parentElement.insertBefore(gift, wrap.nextSibling);


    function currentColour() {
      var c = document.querySelector('input[name="options[Color]"]:checked');
      return c ? c.getAttribute('value') : null;
    }

    function selectedQty() {
      var card = document.querySelector('.quantity-bundle-card[data-selected="true"]')
              || document.querySelector('.quantity-bundle-card');
      return parseInt((card && card.dataset.quantity) || '1', 10) || 1;
    }

    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var cols = p.variants.map(function (v) { return { name: v.title, id: v.id }; });
      if (!cols.length) return;

      // The theme's picker can finish a cold load with no colour selected and
      // an empty hidden variant input, which makes its own Add to Cart button
      // refuse to fire. Select the first colour for the shopper and, if the
      // theme still hasn't filled its hidden input, fill it ourselves. Never
      // runs once a real choice has been made.
      function mbEnsureColour() {
        var hidden = form.querySelector('[name="id"]');
        var checked = document.querySelector('input[name="options[Color]"]:checked');
        if (checked && hidden && hidden.value) return;
        if (!checked) {
          var radios = document.querySelectorAll('input[name="options[Color]"]');
          if (radios.length) {
            var label = radios[0].nextElementSibling;
            if (label && label.tagName === 'LABEL') { label.click(); } else { radios[0].click(); }
            checked = document.querySelector('input[name="options[Color]"]:checked');
          }
        }
        if (hidden && !hidden.value) {
          hidden.value = String(idForCurrentColour());
          hidden.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      [0, 300, 700, 1200, 2000, 3000].forEach(function (d) { setTimeout(mbEnsureColour, d); });
      window.addEventListener('load', function () {
        [100, 600, 1500].forEach(function (d) { setTimeout(mbEnsureColour, d); });
      });

      function idForCurrentColour() {
        var n = currentColour();
        for (var i = 0; i < cols.length; i++) { if (cols[i].name === n) return cols[i].id; }
        var hid = form.querySelector('[name="id"]');
        var v = hid ? parseInt(hid.value, 10) : NaN;
        return isNaN(v) ? cols[0].id : v;
      }

      function draw() {
        var n = selectedQty();
        if (n < 2 || cols.length < 2) { wrap.style.display = 'none'; wrap.innerHTML = ''; return; }
        var prev = [].map.call(wrap.querySelectorAll('select'), function (s) { return s.value; });
        wrap.style.display = 'block';
        var h = '<div class="mb-colour-picker__title">Choose a colour for each one</div>';
        for (var i = 0; i < n; i++) {
          h += '<div class="mb-colour-picker__row"><span class="mb-colour-picker__label">Microscope '
             + (i + 1) + '</span><select class="mb-colour-picker__select">';
          for (var j = 0; j < cols.length; j++) {
            var on = prev[i] ? String(cols[j].id) === prev[i] : cols[j].name === currentColour();
            h += '<option value="' + cols[j].id + '"' + (on ? ' selected' : '') + '>' + cols[j].name + '</option>';
          }
          h += '</select></div>';
        }
        wrap.innerHTML = h;
      }

      var queue = function () { setTimeout(draw, 60); };
      [].forEach.call(document.querySelectorAll('.quantity-bundle-card'), function (c) { c.addEventListener('click', queue); });
      [].forEach.call(document.querySelectorAll('input[name="options[Color]"]'), function (r) { r.addEventListener('change', queue); });
      draw();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var tally = {};
        var selects = wrap.querySelectorAll('select');
        if (selects.length >= 2) {
          [].forEach.call(selects, function (s) { tally[s.value] = (tally[s.value] || 0) + 1; });
        } else {
          tally[idForCurrentColour()] = selectedQty();
        }
        var items = Object.keys(tally).map(function (k) { return { id: parseInt(k, 10), quantity: tally[k] }; });
        if (selectedQty() >= 2) { items.push({ id: GIFT_ID, quantity: 1 }); }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(GIFT_ID), quantity: (selectedQty() >= 2 ? 1 : 0) })
          });
        }).catch(function () {}).then(function () { window.location.href = '/cart'; });
      }, true);
    }).catch(function () {});
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();


/* ===== Default the bundle selector to the Sibling pair. 21 Sep 2026 =====
   The theme renders data-selected="true" on the first card, so the page
   always opened on Single. This clicks the second card once on load so the
   theme's own handler updates the price, the button text and the quantity.
   Stops as soon as the pair is selected, and backs off permanently the
   moment the visitor touches the selector themselves. ===== */
(function mbDefaultBundle() {
  'use strict';
  var done = false;

  function apply() {
    if (done) return;
    var cards = document.querySelectorAll('.quantity-bundle-card');
    if (cards.length < 2) return;
    var pair = cards[1];
    if (pair.dataset.selected === 'true') { done = true; return; }
    var radio = pair.querySelector('input[type="radio"]');
    if (radio && radio.checked) { done = true; return; }
    pair.click();
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quantity-bundle-selector')) done = true;
  }, true);

  [0, 200, 500, 900, 1500, 2200].forEach(function (d) { setTimeout(apply, d); });
  window.addEventListener('load', function () {
    [100, 700, 1400].forEach(function (d) { setTimeout(apply, d); });
  });
})();

/* ===== mb-gift-visibility, 10 Oct 2026 =====
   Free 32GB card now applies to the Sibling pair and Explorer trio only.
   Hides the gift row on the product page when a Single is selected. */
(function mbGiftVisibility() {
  'use strict';
  function qty() {
    var c = document.querySelector('.quantity-bundle-card[data-selected="true"]')
         || document.querySelector('.quantity-bundle-card');
    return parseInt((c && c.dataset.quantity) || '1', 10) || 1;
  }
  function sync() {
    var row = document.getElementById('mb-gift-row');
    if (!row) return;
    row.style.display = (qty() >= 2) ? '' : 'none';
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quantity-bundle-selector')) {
      [60, 200, 500].forEach(function (d) { setTimeout(sync, d); });
    }
  }, true);
  [0, 300, 800, 1500, 2200].forEach(function (d) { setTimeout(sync, d); });
  window.addEventListener('load', function () { [100, 700, 1400].forEach(function (d) { setTimeout(sync, d); }); });
})();
/* ===== mb-faq-height, 11 Oct 2026 =====
   The theme writes an inline max-height on .faq-answer that is computed a few
   pixels short of the real content height, clipping the last line of longer
   answers. Recompute it from the inner element whenever an item is open. */
(function mbFaqHeight() {
  "use strict";
  function fixOne(item) {
    if (!item.classList.contains("active")) return;
    var panel = item.querySelector(".faq-answer");
    var inner = item.querySelector(".faq-answer-inner");
    if (!panel || !inner) return;
    var needed = inner.scrollHeight + 24;
    if (panel.clientHeight < needed) { panel.style.maxHeight = needed + "px"; }
  }
  function fixAll() {
    var items = document.querySelectorAll(".faq-item");
    for (var i = 0; i < items.length; i++) { fixOne(items[i]); }
  }
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest(".faq-item")) {
      [60, 200, 420, 700].forEach(function (d) { setTimeout(fixAll, d); });
    }
  }, true);
  window.addEventListener("resize", fixAll);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fixAll); }
  [300, 900, 1600].forEach(function (d) { setTimeout(fixAll, d); });
})();

/* ===== mb-gallery-first-slide, 11 Oct 2026 =====
   The default variant (Orange) is linked to its own product image, so the
   gallery jumps to the orange shot on load instead of opening on the lifestyle
   photo. Snap it back to the first slide, unless the visitor arrived on a
   deep link that named a specific variant. Colour switching is untouched. */
(function mbGalleryFirstSlide() {
  "use strict";
  var initial = (typeof window.mbInitialSearch === "string") ? window.mbInitialSearch : window.location.search;
  var arrivedWithVariant = /[?&]variant=/.test(initial);
  if (/mbnosnap=1/.test(window.location.search)) { return; }
  if (arrivedWithVariant) { return; }
  var done = false, userTouched = false;
  document.addEventListener("pointerdown", function () { userTouched = true; }, true);
  document.addEventListener("keydown", function () { userTouched = true; }, true);
  function snapToFirst() {
    if (done || userTouched) { return; }
    var list = document.querySelector(".shop-thumbnails");
    if (!list || !list.children.length) { return; }
    var first = list.children[0];
    if (!/(^|\s)active(\s|$)/.test(first.className)) { first.click(); }
    done = true;
  }
  [350, 800, 1400].forEach(function (d) { setTimeout(snapToFirst, d); });
  window.addEventListener("load", function () { setTimeout(snapToFirst, 250); });
})();
